import { toast } from 'react-toastify';
export var successAlert = function successAlert(message) {
  toast.success(message);
};
export var errorAlert = function errorAlert(message) {
  toast.error(message);
};